module.exports = __webpack_public_path__ + "img/empty1.edc53ff2.png";